import React from 'react';
import { rem } from 'polished';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import uniqid from 'uniqid';
import { Input, LabeledCheckbox } from 'oxyrion-ui/lib';

const Wrapper = styled.div`
  width: auto;
`;

const Item = styled.div`
  margin: ${rem(10)};
  z-index: 100;
`;

const ItemsWrapper = styled.div`
  border: ${rem(1)} #eee solid;
  border-radius: ${rem(4)};
  box-shadow: ${({ theme }) => theme.shadow};
  position: absolute;
  width: auto;
  max-width: ${rem(300)};
  z-index: 100;
  background-color: rgb(248, 248, 248);
  border-width: 1px;
  border-style: solid;
  border-color: rgb(166, 166, 166);
  border-image: initial;
`;

const StyledInput = styled(Input)`
  z-index: 10;
`;

class MultiSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: '',
      itemsVisible: false,
      value: [],
      wrapperRef: null,
    };
    this.onClickOutside = this.onClickOutside.bind(this);
  }

  componentDidMount() {
    const { options, value } = this.props;
    // expand option objects with an id field to exclude problems with the same values //
    const optionsWithId = options.map(o => {
      const optionWithId = Object.assign({}, o);
      optionWithId.id = uniqid();
      return optionWithId;
    });
    // work with id instead values
    const checkedOptions = [];
    optionsWithId.forEach(o => {
      if (value.indexOf(o.value) > -1) {
        checkedOptions.push(o.id);
      }
    });
    // eslint-disable-next-line
    this.setState({
      value: checkedOptions,
      options: optionsWithId,
      visibleOptions: optionsWithId,
    });
    document.addEventListener('click', this.onClickOutside);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.options !== prevProps.options) {
      const { options, value } = this.props;
      // expand option objects with an id field to exclude problems with the same values
      const optionsWithId = options.map(o => {
        const optionWithId = Object.assign({}, o);
        optionWithId.id = uniqid();
        return optionWithId;
      });
      // work with id instead values
      const checkedOptions = [];
      optionsWithId.forEach(o => {
        if (value.indexOf(o.value) > -1) {
          checkedOptions.push(o.id);
        }
      });
      // eslint-disable-next-line
      this.setState({
        value: checkedOptions,
        options: optionsWithId,
        visibleOptions: optionsWithId,
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.onClickOutside);
  }

  onClickOutside(e) {
    if (this.state.wrapperRef && !this.state.wrapperRef.contains(e.target)) {
      this.setState({
        itemsVisible: false,
      });
    }
  }

  onCheckBoxClick(item) {
    const { value, options } = this.state;
    const { onChange } = this.props;

    let newValue;

    if (value.indexOf(item) > -1) {
      newValue = value.filter(v => v !== item);
    } else {
      value.push(item);
      newValue = value;
    }
    const valueForReturn = [];

    options.forEach(o => {
      if (newValue.indexOf(o.id) > -1) {
        valueForReturn.push(o.value);
      }
    });

    this.setState(
      {
        value: newValue,
      },
      () => onChange(valueForReturn),
    );
  }

  setWrapperRef(node) {
    const { wrapperRef } = this.state;

    if (node !== wrapperRef) {
      this.setState({
        wrapperRef: node,
      });
    }
  }

  handleChange(e) {
    this.setState({
      text: e.target.value,
      itemsVisible: true,
    });

    this.filter(e.target.value);
  }

  filter(text) {
    const { options } = this.state;

    let visibleOptions = options.filter(v => v.label.startsWith(text));

    if (text === '') {
      visibleOptions = options;
    }
    this.setState({
      visibleOptions,
    });
  }

  toggleItems() {
    if (this.state.itemsVisible) {
      this.setState({
        itemsVisible: false,
      });
    } else {
      this.setState({
        itemsVisible: true,
      });
    }
  }

  render() {
    const { className, placeholder, disabled } = this.props;
    const { text, itemsVisible, value, visibleOptions } = this.state;

    return (
      <Wrapper
        className={className}
        // innerRef={node => this.setWrapperRef(node)}
      >
        <StyledInput
          disabled={disabled}
          placeholder={
            value.length === 0 ? placeholder : `${value.length} zvolené`
          }
          value={text}
          onChange={e => this.handleChange(e)}
          onClick={() => this.toggleItems()}
        />
        {itemsVisible && (
          <ItemsWrapper>
            {visibleOptions.map(item => {
              return (
                <Item key={item.id}>
                  <LabeledCheckbox
                    checked={value.indexOf(item.id) > -1}
                    labelText={item.label}
                    onChange={() => this.onCheckBoxClick(item.id)}
                  />
                </Item>
              );
            })}
          </ItemsWrapper>
        )}
      </Wrapper>
    );
  }
}

MultiSelect.propTypes = {
  disabled: PropTypes.bool,
  className: PropTypes.string,
  value: PropTypes.arrayOf(PropTypes.string),
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ),
};

MultiSelect.defaultProps = {
  disabled: false,
  className: '',

  options: [],
  value: [],
  placeholder: '',
};

MultiSelect.contextTypes = {
  id: PropTypes.string,
};

export default MultiSelect;



// WEBPACK FOOTER //
// ./src/Components/MultiSelect/index.jsx